import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClickOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.99935 18.3332C5.39685 18.3332 1.66602 14.6023 1.66602 9.99984C1.66602 5.39734 5.39685 1.6665 9.99935 1.6665C14.6018 1.6665 18.3327 5.39734 18.3327 9.99984C18.3327 14.6023 14.6018 18.3332 9.99935 18.3332ZM9.99935 16.6665C11.7675 16.6665 13.4632 15.9641 14.7134 14.7139C15.9636 13.4636 16.666 11.7679 16.666 9.99984C16.666 8.23173 15.9636 6.53604 14.7134 5.28579C13.4632 4.03555 11.7675 3.33317 9.99935 3.33317C8.23124 3.33317 6.53555 4.03555 5.2853 5.28579C4.03506 6.53604 3.33268 8.23173 3.33268 9.99984C3.33268 11.7679 4.03506 13.4636 5.2853 14.7139C6.53555 15.9641 8.23124 16.6665 9.99935 16.6665ZM10.8327 9.99984H14.166V11.6665H9.16602V5.83317H10.8327V9.99984Z" })
});
export default SvgClickOutlined;
